import React from "react";
import productbanner from "../../../assets/Images/products/banner.png";

const ProductDetails_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
      <img
        src={productbanner}
        alt="Career"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Product Details
        </h1>

        {/* Description */}
        <p className="text-white text-sm md:text-base mt-3 mb-6 max-w-xl leading-relaxed">
          This product is designed to deliver high performance and reliability.
        </p>

      </div>
    </section>
  );
};

export default ProductDetails_Banner;